const CameraState = {
    panzone : null
}

export default CameraState;